<template>
  <div>
    <!--<div v-if="standard.refines && standard.refines.length>0">
      细化分类：<el-input placeholder="双辛/（辛/癸）烷基二甲基卤化铵/D821-70%/一等品" readonly v-model="standard.selRefine.fullName" style="width: 400px;" class="input-with-select" size="mini">
      <el-button slot="append" icon="el-icon-search" @click="dialogPrice = true"></el-button>
    </el-input>
      <div style="    display: inline-block;
    width: 470px;
    position: relative;
    border-bottom: 1px solid rgb(204, 204, 204);
    bottom: 4px;"></div>
    </div> -->
    <i class="el-icon-caret-right" style="margin-right: 5px;color: #32A08C"></i>
    {{standard.itemName}}
    <el-tag v-if="standard.itemIsGb === '1'" size="mini" type="success" style="margin-left: 5px;">国标</el-tag>
    <el-tag v-if="standard.itemIsGb === '0'" size="mini" type="success" style="margin-left: 5px;">企标</el-tag>
    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="margin-left: 20px;">全选</el-checkbox>
    <el-checkbox-group v-model="checkedStandards" @change="handleCheckedItemsChange">
      <el-checkbox v-for="item in standard.standardList" :label="item" :key="item.itemId">{{item.itemName}}<!--<span style="color:red">（￥{{item.itemPrice}}）</span>--></el-checkbox>
    </el-checkbox-group>
    <el-dialog v-if="dialogPrice"
               title="细化分类"
               center
               :visible.sync="dialogPrice"
               :destroy-on-close = "true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               append-to-body
               width="400px">
      <refinetree :refines="standard.refines" v-model="standard.selRefine"></refinetree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPrice = false">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import refinetree from './refine-tree'
export default {
  components: { refinetree },
  name: 'standard-item',
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    standard: {
      type: Object,
      default: function () {
        return {
          standardList: []
        }
      }
    }
  },
  mounted () {

  },
  data () {
    return {
      showRefineName: '',
      dialogPrice: false,
      checkAll: false,
      checkedStandards: [],
      isIndeterminate: false
    }
  },
  methods: {
    submitClick () {

    },
    handleCheckAllChange (val) {
      this.checkedStandards = val ? this.standard.standardList : []
      this.isIndeterminate = false
    },
    handleCheckedItemsChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.standard.standardList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.standard.standardList.length
    }
  },
  watch: {
    value (newValue) {
      this.checkedStandards = newValue
    },
    checkedStandards (newValue) {
      this.$emit('input', newValue)
      this.$emit('change')
    }
  }
}
</script>
